"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    name: "gost_52535",
    description: "GOST R 52535.1-2006 transliteration schema",
    url: "http://localhost:3000/iuliia/gost-52535/",
    mapping: {
        а: "a",
        б: "b",
        в: "v",
        г: "g",
        д: "d",
        е: "e",
        ё: "e",
        ж: "zh",
        з: "z",
        и: "i",
        й: "i",
        к: "k",
        л: "l",
        м: "m",
        н: "n",
        о: "o",
        п: "p",
        р: "r",
        с: "s",
        т: "t",
        у: "u",
        ф: "f",
        х: "kh",
        ц: "tc",
        ч: "ch",
        ш: "sh",
        щ: "shch",
        ъ: "",
        ы: "y",
        ь: "",
        э: "e",
        ю: "iu",
        я: "ia",
    },
    prev_mapping: null,
    next_mapping: null,
    ending_mapping: null,
    samples: [
        ["Юлия Щеглова", "Iuliia Shcheglova"],
        [
            "Юлия, съешь ещё этих мягких французских булок из Йошкар-Олы, да выпей алтайского чаю",
            "Iuliia, sesh eshche etikh miagkikh frantcuzskikh bulok iz Ioshkar-Oly, da vypei altaiskogo chaiu",
        ],
    ],
};
